import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames'

export const BackButton = ({onClick}) => {
  return  (
    <button className='btn btn-link btn-pseudo' onClick={onClick}>
      <span className="blade-left-arrow" />
    </button>
  );
}

BackButton.propTypes = {
  onClick: PropTypes.func.isRequired
};

export const GlobalHeader = (props) => {

  const renderLeft = () => {
    return  (
      <div className="left">
        {props.leftComponent}
      </div>
    );
  }

  const renderRight = () => {
    return  (
      <div className="right">
        {props.rightComponent}
      </div>
    );
  }

  const renderTitle = () => {
    let TitleComponent = props.titleComponent;

    return <TitleComponent>{props.title}</TitleComponent>;
  }

  const renderSubTitle = () => {
    if(!props.subTitle) return;

    let SubTitleComponent = props.subTitleComponent;

    return <SubTitleComponent>{props.subTitle}</SubTitleComponent>;
  }

  const renderCenter = () => {
    return  (
      <div className="center">
        {renderTitle()}
        {renderSubTitle()}
      </div>
    );
  }

  return (
    <div
      className={classnames('global-header-v2', props.additionalClasses.join(' '))}>
      {renderLeft()}
      {renderCenter()}
      {renderRight()}
    </div>
  );
};

GlobalHeader.propTypes = {
  showMenu: PropTypes.bool,
  titleComponent: PropTypes.func,
  subTitleComponent: PropTypes.func,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  additionalClasses: PropTypes.array
};

GlobalHeader.defaultProps = {
  showMenu: true,
  titleComponent: props => <h2>{props.children}</h2>,
  subTitleComponent: props => <p>{props.children}</p>,
  title: '',
  subTitle: '',
  additionalClasses: []
};
